// eslint-disable-next-line prefer-destructuring
export const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// eslint-disable-next-line prefer-destructuring
export const REACT_APP_TOP_NAVIGATION = process.env.REACT_APP_TOP_NAVIGATION;
// eslint-disable-next-line prefer-destructuring
export const REACT_APP_LANDING = process.env.REACT_APP_LANDING;
// eslint-disable-next-line prefer-destructuring
export const REACT_APP_FOOTER = process.env.REACT_APP_FOOTER;
// eslint-disable-next-line prefer-destructuring
export const REACT_APP_SEARCH = process.env.REACT_APP_SEARCH;
